import React, { useState } from "react";
import { Col, Pagination, Row } from "react-bootstrap";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { left, right } from "../../assets/img";

const ScreenPagination = ({
  show,
  amount,
  setPagenumber = () => { },
  pagenumber = 1,
  todayAmount = 0,
  totalPages = 0,
  selectedDate = '',
  pagiantionFalse,
  marignBtn,
}) => {
  const [pagination, setPagination] = useState("");
  const [page, setPage] = useState(1);

  const inputValue = pagenumber === "" ? "" : String(pagenumber);


  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="screen-pagination">
      {show && (
        <div style={{ marginBottom: marignBtn ? marignBtn : 0 }} className="d-flex ac-jb bg-primary1 white p-2 px-3">
          <p className="f3 fs-xs-14 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-20   ">
            {" "}
            {amount ? `${selectedDate || 'Today'} Winning Amount` : "Today Price"}{" "}
          </p>
          <p className="f3 fs-xs-14 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-20  ">
            {" "}
            ₹ {todayAmount}
          </p>
        </div>
      )}
      {!pagiantionFalse && (
        <div className="justify-content-between  w-100 bottom-pagintion px-3">
          <div style={{ height: 38, marginBottom: 5 }} className="d-flex ac-jb  w-100">
            <p className="px-1 mb-0 f3 fs-14">Total Pages {totalPages}</p>
            <div className="gap-1 pointer mb-0 d-flex ac-js">
              {pagenumber > 1 && totalPages > 1 && (
                <img
                  src={left}
                  width={22}
                  height={24}
                  alt=""
                  onClick={() => {
                    setPagenumber((pagenumber) =>
                      pagenumber > 1 ? pagenumber - 1 : 1
                    );
                  }}
                />
                // <PlayArrowIcon className="left-arrow" onClick={() => {
                //     setPagenumber((pagenumber) => pagenumber > 1 ? pagenumber - 1 : 1)
                // }}
                // />
              )}
              <input
                type="number"
                style={{
                  width: "26px",
                  minWidth: "26px",
                  height: "26px",
                  borderRadius: "8px",
                  position: "relative",
                  paddingBottom: isIOS ? 2 : 2,
                  fontSize: 12,
                }}
                className="form-control1 mx-1 text-center"
                value={inputValue}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  let val = e.target.value;

                  // ✅ Allow empty (for clearing)
                  if (val === "") {
                    setPagenumber("");
                    return;
                  }

                  // ✅ Remove leading zeros (01 → 1)
                  val = val.replace(/^0+/, "");

                  const num = Number(val);

                  if (num < 1) {
                    setPagenumber(1);
                  } else if (num > totalPages) {
                    setPagenumber(totalPages);
                  } else {
                    setPagenumber(num);
                  }
                }}
                onBlur={() => {
                  // ✅ Final safety check
                  if (inputValue === "" || Number(inputValue) < 1) {
                    setPagenumber(1);
                  }
                }}
              />

              {pagenumber < totalPages && totalPages > 1 && (
                <img
                  src={right}
                  onClick={() => {
                    setPagenumber((prev) =>
                      prev < totalPages ? prev + 1 : totalPages
                    );
                  }}
                  width={22}
                  height={24}
                  alt=""
                />
              )}
              {/* <PlayArrowIcon className="right-arrow" onClick={() => {
                                    setPagenumber(pagenumber + 1)
                                }}
                                /> */}
            </div>
          </div>
        </div>)}
    </div>
  );
};

export default ScreenPagination;
